import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnswersComponent } from './answers.component';
import { RouterModule, Routes } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { AnswersCommentsComponent } from './answers-comments/answers-comments.component';
import { AnswersStoriesComponent } from './answers-stories/answers-stories.component';

const ANGULAR_MATERIAL_MODULES = [
  MatListModule
];

const COMPONENTS = [
  AnswersComponent, AnswersCommentsComponent, AnswersStoriesComponent
];

export const answers_nav_path = {
  answersComments: '/answers/comments',
  answersStories: '/answers/stories'
};

const routes: Routes = [
  { path: '', component: AnswersComponent, pathMatch: 'full' },
  { path: 'comments', component: AnswersCommentsComponent },
  { path: 'stories', component: AnswersStoriesComponent }
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    RouterModule.forChild(routes), CommonModule, ...ANGULAR_MATERIAL_MODULES
  ],
  exports: [RouterModule, ...COMPONENTS]
})
export class AnswersModule { }
